import { useRecoilValue } from "recoil";
import { Icon as BPIcon } from "@blueprintjs/core";

import { Button, Flex, Icon, Span } from "@goodfill/ui-components";
import { filterPopupDockedState } from "../../../../state";

interface Props {
  clickHandlers: {
    onClickReset: () => void;
    onClickClose: () => void;
    onClickDock: () => void;
  };
  title: string;
}

export const BondFilterHeader: React.FC<Props> = ({
  clickHandlers: { onClickReset, onClickClose, onClickDock },
  title,
}) => {
  const filterIsDocked = useRecoilValue(filterPopupDockedState);

  return (
    <Flex horizontalMargin={2} verticalMargin={2} justify="between" className="py-2">
      <Flex justify="start">
        <Span font="semibold" size="2xl">
          {title}
        </Span>
      </Flex>

      <Flex direction="row" items="center" gap={1}>
        <Button fill size="small" onClick={onClickDock} lightBlue={filterIsDocked}>
          <BPIcon iconSize={20} icon={filterIsDocked ? "lock" : "unlock"} />
        </Button>
        <Button fill size="small" onClick={onClickReset}>
          <Icon name="arrow-circle" size="1.25em" />
        </Button>

        <Button fill size="small" onClick={onClickClose}>
          <Icon name="x" size="1.25em" />
        </Button>
      </Flex>
    </Flex>
  );
};
